import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { TrendingUp } from "lucide-react";
import { http, EDITION_COLORS } from "../../lib/api";

const colour = (e) => (EDITION_COLORS[e] || { border: "#A8A29E" }).border;
const label = (e) => (e === "other" ? "Deleted kits" : e[0].toUpperCase() + e.slice(1));
const wk = (d) => new Date(d + "T00:00:00").toLocaleDateString("en-AU", { day: "numeric", month: "short" });

export const CostTrend = () => {
  const [d, setD] = useState(null);
  useEffect(() => { http.get("/settings/credit/trend").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const eds = [...new Set(d.weeks.flatMap((w) => Object.keys(w).filter((k) => k !== "week")))];
  return (
    <div data-testid="cost-trend" className="rounded-xl border border-stone-200 bg-white p-5 mb-6">
      <div className="eyebrow flex items-center gap-2"><TrendingUp size={12} /> Weekly AI spend · last 4 weeks <span data-testid="cost-trend-total" className="ml-2 normal-case tracking-normal text-stone-500">≈ ${d.total.toFixed(2)} total</span></div>
      {!eds.length ? <p data-testid="cost-trend-empty" className="text-sm text-stone-500 mt-3">No tracked spend yet — the chart fills in as kits are built.</p> : (
        <div className="mt-4 grid gap-6 lg:grid-cols-[1fr_320px]">
          <div className="h-56" data-testid="cost-trend-chart">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={d.weeks}>
                <XAxis dataKey="week" tickFormatter={wk} tick={{ fontSize: 12 }} stroke="#a8a29e" />
                <YAxis tickFormatter={(v) => `$${v}`} tick={{ fontSize: 12 }} stroke="#a8a29e" width={48} />
                <Tooltip formatter={(v, n) => [`$${Number(v).toFixed(2)}`, label(n)]} labelFormatter={(l) => `Week of ${wk(l)}`} />
                <Legend formatter={label} wrapperStyle={{ fontSize: 12 }} />
                {eds.map((e) => <Bar key={e} dataKey={e} stackId="s" fill={colour(e)} />)}
              </BarChart>
            </ResponsiveContainer>
          </div>
          <table data-testid="cost-trend-table" className="text-sm self-start w-full">
            <thead><tr className="text-left text-[11px] uppercase tracking-wider text-stone-400"><th className="pb-2">Edition</th><th className="pb-2 text-right">Kits</th><th className="pb-2 text-right">Avg / kit</th></tr></thead>
            <tbody>{d.editions.map((t, i) => (
              <tr key={t.edition} data-testid={`cost-trend-row-${t.edition}`} className="border-t border-stone-100">
                <td className="py-1.5"><span className="inline-block w-2.5 h-2.5 rounded-full mr-2" style={{ background: colour(t.edition) }} />{label(t.edition)}{i === 0 && d.editions.length > 1 && <span className="ml-2 text-[10px] font-bold uppercase text-amber-600">Most expensive</span>}</td>
                <td className="py-1.5 text-right">{t.kits}</td>
                <td className="py-1.5 text-right font-semibold">${t.avg.toFixed(2)}</td>
              </tr>))}</tbody>
          </table>
        </div>
      )}
    </div>
  );
};
